import {ReactNode} from "react";
import {SidebarFunctionGlobals} from "../../document/components/pdf/SidebarFunctions";
import FunctionHelper from "../../../shared/helper/FunctionHelper";
import FormsEditToolbarFunction from "./FormsEditToolbarFunction";
import {I18nGlobals} from "../../../shared/translation/i18nInterface";
import {PortalGlobals} from "../../Portal";
import {DebugGlobals} from "../../dialog/components/settings/DebugDialog";
import {HelperGlobals} from "../../../shared/components/Helper";
import {FormLayerGlobals} from "../pdf/form/FormLayerInterface";
import MouseMode from "../settings/MouseMode";
import Immutable from "../../../shared/immutable/Immutable";
import PortalDocument, {PortalDocumentInterface} from "../../document/PortalDocument";
import DocumentSettings from "../../document/DocumentSettings";
import PortalPureComponent from "../../../shared/components/PortalPureComponent";

export interface ViewerToolbarProperties extends SidebarFunctionGlobals, I18nGlobals, PortalGlobals, DebugGlobals,
	HelperGlobals, FormLayerGlobals {
	portalDocument?: Immutable<PortalDocumentInterface>;
}

export default class ViewerToolbar extends PortalPureComponent<ViewerToolbarProperties, any> {

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		if (!FunctionHelper.exists(this.props.portalDocument?.value)) {
			return null;
		}

		let portalDocument: PortalDocument = this.props.context.documentManager.findDocument(
			this.props.portalDocument!.get().id!
		);
		let documentSettings: DocumentSettings = portalDocument.getSettings();

		let classList: Array<string> = ["viewer-toolbar", "toolbar"];
		if ([
			this.props.showFormsEditFunction && documentSettings?.activeViewer.mouseMode === MouseMode.FORM
		].includes(true)) {
			classList.push("in");
		}

		return (
			<div className={classList.join(" ")}>
				{FunctionHelper.applyValue(this.props.showFormsEditFunction, false) &&
					<FormsEditToolbarFunction {...this.props} parameter={this.props.formsEditFunctionParameter}
											  visible={FunctionHelper.applyValue(
												  this.props.showFormsEditFunction, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showFormsEditFunction: false
											  })}/>
				}
			</div>
		)
	}
}